import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const DivText = styled.div((props) => ({
  display:'flex',
  justifyContent:`${props.left?'flex-start':props.right?'flex-end':'center'}`,

  'div.priority.urgent': {
    background: '#FF0000',
    borderRadius: '2px',
    color: '#FFF',
    fontWeight: 'bold',
    padding: '2px 5px',
  }
}))

export const RowFields = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
})
